import React from "react";
import {
  TipButtonStyled,
  TipButtonContainer,
  PayoutButtonsContainer,
} from "../tips.styled";
import { Color } from "config/colors";
import { useTranslation } from "react-i18next";
import { TipFilter, PayoutType, TipDetails } from "model/Tip";

type FooterButtonsProps = {
  tipsList: TipDetails[];
  selectedTips: number[];
  selectedFilter: TipFilter;
  onPayout: (ids: number[], type: PayoutType) => void;
  calculateAndOpenModal: (
    tipIds: number[],
    type?: "manual" | "swish" | undefined
  ) => void;
  setIsManualPayoutModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setPayoutType: React.Dispatch<
    React.SetStateAction<"manual" | "swish" | undefined>
  >;
};

export const FooterButtons: React.FC<FooterButtonsProps> = (props) => {
  const { t } = useTranslation();

  const selectedTipsWithAmountZero = props.selectedTips.some((tipId) => {
    const tip = props.tipsList.find((t) => t.companyTipId === tipId);
    return tip?.amount === 0;
  });

  if (props.selectedFilter === TipFilter.PaidOut) return null;

  return (
    <TipButtonContainer
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      {props.selectedFilter === TipFilter.ReadyToPayout ? (
        <PayoutButtonsContainer>
          <TipButtonStyled
            backgroundColor={Color.MidnightBlue}
            onClick={() =>
              props.onPayout(props.selectedTips, PayoutType.Manual)
            }
            disabled={props.selectedTips.length === 0}
          >
            {t("CompanyTip.MarkAsManuallyPaidPlural")} (
            {props.selectedTips.length})
          </TipButtonStyled>
          <TipButtonStyled
            backgroundColor={Color.MidnightBlue}
            onClick={() =>
              props.onPayout(props.selectedTips, PayoutType.Automatic)
            }
            disabled={props.selectedTips.length === 0}
          >
            {t("CompanyTip.PayoutWithSwish")} ({props.selectedTips.length})
          </TipButtonStyled>
        </PayoutButtonsContainer>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <TipButtonStyled
            backgroundColor={Color.MidnightBlue}
            onClick={() => props.calculateAndOpenModal(props.selectedTips)}
            disabled={
              props.selectedTips.length === 0 || selectedTipsWithAmountZero
            }
            style={{ marginRight: 10 }}
          >
            {t("CompanyTip.DistributeSelectedDays")} (
            {props.selectedTips.length})
          </TipButtonStyled>
          <TipButtonStyled
            backgroundColor={Color.MidnightBlue}
            onClick={() => {
              props.setPayoutType("manual");
              props.setIsManualPayoutModalOpen(true);
            }}
            disabled={props.selectedTips.length === 0}
          >
            {t("CompanyTip.MarkAsManuallyPaidPlural")} (
            {props.selectedTips.length})
          </TipButtonStyled>
          <TipButtonStyled
            backgroundColor={Color.MidnightBlue}
            onClick={() => {
              props.setPayoutType("swish");
              props.setIsManualPayoutModalOpen(true);
            }}
            disabled={props.selectedTips.length === 0}
            style={{ marginLeft: 10 }}
          >
            {t("CompanyTip.PayoutWithSwishPlural")} ({props.selectedTips.length}
            )
          </TipButtonStyled>
        </div>
      )}
    </TipButtonContainer>
  );
};
